import * as React from "react";
import Container from "./styled";
import { Fade } from "react-awesome-reveal";

export default function Card({ image, alt, title, text, link }) {
  return (
    <Container>
      {/* Card Container */}
      <Fade delay={100} duration={800} className="card-container">
        {/* Data Container */}
        <section>
          {/* Logo & Title Container */}
          <div id="logo-title-container">
            {/* Logo */}
            <img src={image} alt={alt}></img>
            {/* Button */}
            <p>{title}</p>
          </div>
          {/* Text & Button Container */}
          <div id="text-button-container">
            {/* Text */}
            <p>{text}</p>
            {/* Button */}
            <a href={link} target="_blank">
              Cotizar
            </a>
          </div>
        </section>
      </Fade>
    </Container>
  );
}
